import { render, staticRenderFns } from "./wincal-point.vue?vue&type=template&id=3f95544e&scoped=true&"
import script from "./wincal-point.vue?vue&type=script&lang=js&"
export * from "./wincal-point.vue?vue&type=script&lang=js&"
import style0 from "./wincal-point.vue?vue&type=style&index=0&id=3f95544e&prod&scoped=true&lang=css&"
import style1 from "./wincal-point.vue?vue&type=style&index=1&id=3f95544e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f95544e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContent,VOverlay,VProgressCircular})
